var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFood = function SvgFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "M12 4.5a7.5 7.5 0 0 0-7.484 7c-.018.275.208.5.484.5h14a.476.476 0 0 0 .484-.5A7.5 7.5 0 0 0 12 4.5Zm-8 12a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v0a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm.5-2.5h15"
  })));
};
export { SvgFood as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIHN0cm9rZT0iIzdBNzM1OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTIgNC41YTcuNSA3LjUgMCAwIDAtNy40ODQgN2MtLjAxOC4yNzUuMjA4LjUuNDg0LjVoMTRhLjQ3Ni40NzYgMCAwIDAgLjQ4NC0uNUE3LjUgNy41IDAgMCAwIDEyIDQuNVpNNCAxNi41YS41LjUgMCAwIDEgLjUtLjVoMTVhLjUuNSAwIDAgMSAuNS41djBhMyAzIDAgMCAxLTMgM0g3YTMgMyAwIDAgMS0zLTN2MFpNNC41IDE0aDE1Ii8+PC9zdmc+";